import { render } from "./StudentsCards.vue?vue&type=template&id=f1c16fe0&scoped=true"
import script from "./StudentsCards.vue?vue&type=script&lang=js"
export * from "./StudentsCards.vue?vue&type=script&lang=js"

import "./StudentsCards.vue?vue&type=style&index=0&id=f1c16fe0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1c16fe0"]])

export default __exports__